import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { PromoRequestFilters, PromoRequestRes, getPromoCodeRequests } from '~/services/PromoService';

export const promoRequestsQueryKeys = {
  all: ['promo-requests'] as const,
  lists: () => [...promoRequestsQueryKeys.all, 'list'] as const,
  list: (filters: PromoRequestFilters) => [...promoRequestsQueryKeys.lists(), filters] as const,
};

type Params = {
  filters: PromoRequestFilters;
  enabled?: boolean;
};

export function useGetPromoRequests({ filters, enabled = true }: Params) {
  return useQuery<PromoRequestRes>({
    queryKey: promoRequestsQueryKeys.list(filters),
    queryFn: async ({ signal }) => {
      const response = await getPromoCodeRequests(filters, { signal });
      if (response.status !== 200) {
        throw new Error(response.message || JSON.stringify(response) || 'Failed to fetch promo requests');
      }
      return response;
    },
    enabled,
    placeholderData: keepPreviousData,
  });
}
